const dataVisualizationColorSchema = {
	health_plan: "#F08080   ",
	clinic_card: "#F28C87   ",
	group_short_term_disability: "#F59D92   ",
	group_short_term_visaibility_class_1: "#F6A296   ",
	group_short_term_visaibility_class_2: "#F8AD9D   ",
	hoo: "#FAB9A4   ",
	ksop: "#FBC4AB   ",
	gLI: "#FDCFB2   ",
	ccef: "#FFDAB9   "
};

const dataVisualizationPieChartColorSchema = {
	health_plan: "#FFADAD   ",
	clinic_card: "#FFD6A5   ",
	group_short_term_disability: "#FDFFB6   ",
	group_short_term_visaibility_class_1: "#CAFFBF   ",
	group_short_term_visaibility_class_2: "#9BF6FF   ",
	hoo: "#A0C4FF   ",
	ksop: "#BDB2FF   ",
	gLI: "#FFC6FF   ",
	ccef: "#BDCDD6   "
};

export const DATA_VISUALIZATION_COLOR_SCHEMA = dataVisualizationColorSchema;
export const DATA_VISUALIZATION_PIE_CHART_COLOR_SCHEMA = dataVisualizationPieChartColorSchema;

//new

export const BBI_CORE_DATA_VISUALIZATION_COLOR_SCHEMA = {
	health_plan: "#F08080   ",
	clinic_card: "#F28C87   ",
	group_short_term_disability: "#F59D92   ",
	group_short_term_visaibility_class_1: "#F6A296   ",
	group_short_term_visaibility_class_2: "#F8AD9D   ",
	hoo: "#FAB9A4   ",
	ksop: "#FBC4AB   ",
	gLI: "#FDCFB2   ",
	cce: "#FFDAB9   "
};
